import * as React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import SmallTitle from '../../../../shared/library/typography/small-title';
import {WHITE, ASH} from '../../../../shared/style/colors';
import ComparisonItem from './comparison-item';

const ServiceImageContainer = glamorous.div({
  display: 'inline-block',
  borderRadius: 2,
  border: `1px solid ${ASH}`,
  backgroundColor: WHITE,
  padding: 6,
  lineHeight: '100%'
});

const ServiceNameContainer = glamorous.div({
  flex: 1,
  paddingLeft: 8
});

export default function ComparisonService(props) {
  const {service, onRemoveClick} = props;

  return (
    <ComparisonItem onRemoveClick={onRemoveClick}>
      <ServiceImageContainer>
        <img src={service.image_url} width="14" height="14" alt={service.name} />
      </ServiceImageContainer>
      <ServiceNameContainer>
        <SmallTitle>{service.name}</SmallTitle>
      </ServiceNameContainer>
    </ComparisonItem>
  );
}

ComparisonService.propTypes = {
  service: PropTypes.object.isRequired,
  onRemoveClick: ComparisonItem.propTypes.onRemoveClick
};
